// Deterministic suggested automation cadence for a Task, ported from the
// Lovable box-flow-delight reference (src/lib/suggestAutomation.ts). Webhook is
// reserved for Tasks whose copy clearly reacts to an incoming event; the rest
// map to a schedule bucket via a stable hash, so the label never shuffles
// between renders.
const SCHEDULES = [
  "Schedule Daily",
  "Schedule Weekly",
  "Schedule Monthly",
  "Schedule Annually",
];

const WEBHOOK_RE =
  /(webhook|incoming|received|reply|inbound|when .* arrives|on new|trigger)/;

const suggestAutomation = ({ title = "", description = "" } = {}) => {
  // Task descriptions arrive as HTML from the backend; strip tags so the hash
  // and the webhook test read the words, not the markup.
  const plain = String(description).replace(/<[^>]*>/g, " ");
  const blob = `${title} ${plain}`.toLowerCase();
  if (WEBHOOK_RE.test(blob)) return "By Webhook";

  let hash = 0;
  for (let i = 0; i < blob.length; i++) {
    hash = (hash * 31 + blob.charCodeAt(i)) | 0;
  }
  return SCHEDULES[Math.abs(hash) % SCHEDULES.length];
};

export default suggestAutomation;
